module.exports = __webpack_public_path__ + "img/s-hd.7546d196.webp";